import React from "react";
import { Card, CardBody, CardTitle } from "reactstrap";
import ReactApexChart from "react-apexcharts";

const FinansGrafik = ({ series = [] }) => {
  const data = series.length > 0 ? series : [];
  const apexSeries = [{ name: "Sistem Cirosu (TL)", data: data.map((d) => d.value) }];

  const options = {
    chart: { type: "area", height: 240, toolbar: { show: false } },
    colors: ["#556ee6"],
    dataLabels: { enabled: false },
    stroke: { curve: "smooth", width: 2 },
    fill: {
      type: "gradient",
      gradient: { shadeIntensity: 1, opacityFrom: 0.45, opacityTo: 0.05, stops: [20, 100, 100, 100] },
    },
    xaxis: { categories: data.map((d) => d.month) },
    yaxis: { labels: { formatter: (value) => Number(value).toLocaleString("tr-TR") + " TL" } },
    tooltip: { y: { formatter: (value) => Number(value).toLocaleString("tr-TR") + " TL" } },
  };

  return (
    <Card className="shadow-sm border-0 h-100">
      <CardBody>
        <CardTitle className="mb-3">Son 12 Ay — Aylık İşlem Hacmi</CardTitle>
        {data.length === 0 ? (
          <div className="text-center text-muted py-5">Henüz veri yok.</div>
        ) : (
          <ReactApexChart series={apexSeries} options={options} type="area" height={240} className="apex-charts" />
        )}
      </CardBody>
    </Card>
  );
};

export default FinansGrafik;
